<template>
  <div v-if="renderReady && !model.$disabled">
    <div class>
      <div v-if="prependicon" class="input-group-prepend">
        <span class="input-group-text">
          <i v-if="prependicon" class="icon-prepend fa" :class="prependicon.startsWith('fa-') ? prependicon : ''">{{
            prependicon.startsWith('fa-') ? '' : prependicon
          }}</i>
        </span>
      </div>

      <label v-if="getTitle" class="label-width" :for="sid">
        <template v-if="!setTitleAsPlaceholder">{{ getTitle }}</template>

        <w-tooltip v-if="tooltipContent && tooltipContent.length">{{ tooltipContent }}</w-tooltip>
      </label>

      <div
        v-if="mock"
        class="form-control"
        readonly
        :class="{ borderless: borderless, 'text-right': textRight, ...borderValidationClass }"
      >
        <slot>{{ model.$model }}</slot>
      </div>

      <input
        v-else-if="mask"
        :id="sid"
        ref="input"
        v-mask="mask"
        class="form-control"
        :aria-invalid="errorVisible"
        :aria-describedby="showError && errorVisible ? errId : undefined"
        :aria-required="model.$schema.fieldRequired === true"
        :placeholder="getPlaceholder"
        :title="titleAttribute || model.$schema.title"
        :type="type"
        :class="{ borderless: borderless, 'text-right': textRight, ...borderValidationClass }"
        :style="appendiconTextRight"
        :disabled="disabled"
        :readonly="model.$schema.readOnly"
        :value="svalue"
        :name="model.$form.testPath ? model.$path : undefined"
        :step="step"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
        v-on="listenersWithout('input', 'focus', 'blur')"
      />

      <input
        v-else
        :id="sid"
        ref="input"
        class="form-control"
        :aria-invalid="errorVisible"
        :aria-describedby="showError && errorVisible ? errId : undefined"
        :aria-required="model.$schema.fieldRequired === true"
        :placeholder="getPlaceholder"
        :title="titleAttribute || model.$schema.title"
        :type="type"
        :class="{ borderless: borderless, 'text-right': textRight, ...borderValidationClass }"
        :style="appendiconTextRight"
        :disabled="disabled"
        :readonly="model.$schema.readOnly"
        :value="svalue"
        :name="model.$form.testPath ? model.$path : undefined"
        :step="step"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
        v-on="listenersWithout('input', 'focus', 'blur')"
      />

      <div v-if="prependicon" class="input-group-append">
        <span class="input-group-text">
          <i v-if="appendicon" class="icon-append fa" :class="appendicon.startsWith('fa-') ? appendicon : ''">
            {{ appendicon.startsWith('fa-') ? '' : appendicon }}
          </i>
        </span>
      </div>

      <w-error v-if="showError" :err-id="errId" :model="model" @focus="$refs.input.focus()" />
    </div>
  </div>
</template>

<script>
import { VueMaskDirective } from 'v-mask';

import modelMixin from '../mixins/modelMixin';
import { errorMixin } from '../mixins/errorMixin';
import WError from './error.vue';
import WTooltip from './tooltip.vue';

// @vuese
// Input z opcjonalną maską
// @group Components
export default {
  name: 'WInput',
  components: { WError, WTooltip },
  directives: { mask: VueMaskDirective },
  mixins: [modelMixin, errorMixin('inp')],
  props: {
    // Czy input ma być sztuczny (tylko do wyświetlania wartości, ze slotem)
    mock: { type: Boolean, default: false },
    // Placeholder
    placeholder: { type: String },
    // Typ
    type: { type: String, default: 'text' },
    // Ikona do dodania przed inputem
    appendicon: { type: String, default: '' },
    // Ikona do dodania za inputem
    prependicon: { type: String, default: '' },
    // Tytuł jako placeholder
    setTitleAsPlaceholder: { type: Boolean, default: false },
    // Czy pokazywać błędy
    showError: { type: Boolean, default: true },
    // Atrybut z tytułem
    titleAttribute: { type: String, default: '' },
    // Maska inputa (na podstawie https://www.npmjs.com/package/v-mask)
    mask: { type: [String, Function, Object], required: false },
    // Dokładność inputa (typu number, time, itp.)
    step: { type: [String, Number], required: false }
  },
  computed: {
    textRight() {
      return (
        this.model.$schema.type === 'number' ||
        this.model.$schema.type === 'money' ||
        this.model.$schema.type === 'integer'
      );
    },
    appendiconTextRight() {
      return this.textRight && this.appendicon ? { paddingRight: '35px!important' } : {};
    },
    getPlaceholder() {
      if (this.setTitleAsPlaceholder) {
        return this.getTitle;
      }
      return this.placeholder;
    }
  }
};
</script>

<style>
.label-width {
  width: 100%;
}
</style>
